export default __webpack_public_path__ + "static/media/artbnk.2e34e1c2.svg";